import { render, staticRenderFns } from "./FootRightVR.vue?vue&type=template&id=6e3caa62&"
import script from "./FootRightVR.vue?vue&type=script&lang=js&"
export * from "./FootRightVR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports